export default "__VITE_ASSET__BDjEahkZ__"